import { render, staticRenderFns } from "./WechatLoginView.vue?vue&type=template&id=b591de4e"
import script from "./WechatLoginView.vue?vue&type=script&lang=js"
export * from "./WechatLoginView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports